// tries to update sw. This should refresh the page soon after calling.
export async function UpdateSW(): Promise<void> {
  if (navigator.serviceWorker) {
    const registration = await navigator.serviceWorker.getRegistration();
    if (registration) {
      await registration.update();
    }
  }
}
